module.exports = __webpack_public_path__ + "media/winner_full_house_2.609d8176.mp3";